import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useRequest } from "ahooks";
/*
Dynamically get list data (Just for Antd Select Component hook):
1. The service must return to the list;
2. The service supports parameters name__icontains and id__in;

TODD:
1. Should provide a base search component;
*/

interface ISelectSearchData {
  service: (params: any) => Promise<any>;
  initialValues?: number | number[];
  keyName?: string;
  ready?: boolean;
}

const useSelectSearchData = ({
  service,
  initialValues,
  ready = true,
  keyName = "name__icontains",
}: ISelectSearchData) => {
  const { data: selectedData = [], run: getSelectedData, loading: loadingSelected } = useRequest(
    service,
    {
      ready,
      manual: true,
    },
  );

  useEffect(() => {
    if (initialValues) {
      getSelectedData({
        id__in: Array.isArray(initialValues) ? initialValues.join(",") : initialValues,
      });
    }
  }, [initialValues]);

  const [keyWord, setKeyword] = useState("");
  const { data: optionData = [], loading: loadingList, run } = useRequest(
    () => service({ [keyName]: keyWord, page_size: 50 }),
    {
      ready,
      refreshDeps: [keyWord],
    },
  );

  const cacheRef = useRef({});

  // merge options
  const data = useMemo(() => {
    const cacheArray = Object.keys(cacheRef.current).map((key) => cacheRef.current[key]);
    const mergedArr = [...selectedData, ...cacheArray, ...optionData];

    const uniqueIds = new Set();
    const unique = mergedArr.filter((item) => {
      const isDuplicate = uniqueIds.has(item.value);
      uniqueIds.add(item.value);
      if (!isDuplicate) {
        return true;
      }
      return false;
    });
    return unique;
  }, [selectedData, optionData]);

  // cache user select option (include onChange callback).
  // prevent list missing selected item.
  const addCache = useCallback((val) => {
    const exists = data.find((item) => item.value === val);
    if (exists) {
      cacheRef.current[val] = exists;
    }
  }, [data]);

  return {
    data,
    loading: loadingSelected || loadingList,
    run,
    getSelectedData,
    setKeyword,
    addCache,
  };
};

export default useSelectSearchData;
